module.exports = __webpack_public_path__ + "static/a-man-with-blue-bg-3b77931a4bd86a9dacb172f8fc25c239.jpg";